if (!Array.isArray) {
  Array.isArray = (arg) => {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
}



/** WEBPACK FOOTER **
 ** ./src/polyfills/is_array.js
 **/